import { CaseIdToFolder } from '@/pages/casePage/types'

export const getUniqueGiftKey = (caseId: number) => {
  switch (caseId) {
    case CaseIdToFolder.trending:
      return 'trending'
    case CaseIdToFolder.tgGift:
      return 'tgGift'
    case CaseIdToFolder.gamed:
      return 'gamed'
    case CaseIdToFolder.vavilova:
      return 'vavilova'
    case CaseIdToFolder.steamDeck:
      return 'steamDeck'
    case CaseIdToFolder.cargo:
      return 'cargo'
    case CaseIdToFolder.ps5:
      return 'ps5'
    default:
      return undefined
  }
}
